import _ from 'lodash';

import { route } from '../helpers';
import urls from '../../urls';
import { JourneyPlannerLayout, PointStages } from '../../constants/AppConstants';
import CurrentTripStore from '../../stores/CurrentTripStore';
import JourneyStore from '../../stores/JourneyStore';
import UserStore from '../../stores/UserStore';
import TripActions from '../../actions/TripActions';
import SearchActions from '../../actions/SearchActions';
import { openInAppVersionEndingModal } from '../../helpers/InAppModal';
import { InvalidSearchError } from '../../errors/Search';

export default route(PointStages.CHOOSE_OUTWARD, {
    shouldRefocusRouteContent() {
        return false;
    },
    getComponent(location, cb) {
        require.ensure(
            [],
            (require) => {
                cb(null, require('../../components/serviceList/v2/ServiceListContainer').default);
            },
            () => {
                // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
                // TODO: use a smarter way to get an updated chunk
                window.location.reload();
            },
            'point-outward');
    },

    async onComponentLoad (nextState, replace, callback, forcePlusBus = false) {
        const { params, location } = nextState;

        let search = await SearchActions.loadFromParams(params, location.query);

        if (search.targetLayout !== JourneyPlannerLayout.LIST) {
            search = search.setTargetLayout(JourneyPlannerLayout.LIST);
            SearchActions.update(search);
        }
        const isValidSearch = search.isValid();
        if (!isValidSearch) {
            replace(urls.location(PointStages.SEARCH, null, location.query));
        }

        const trip = CurrentTripStore.get().set('listStep', location.query.step);
        TripActions.updateTrip(trip);
        const isCurrentSearch = JourneyStore.isCurrentSearch(search);

        if (!isCurrentSearch) {
            try {
                const user = UserStore.getCurrent();
                await SearchActions.search({search, user});
                if (trip.isPlusBusAvailable()) {
                    TripActions.loadPlusBusAvailability(trip);
                }
                openInAppVersionEndingModal();
                _.defer(callback);
            } catch (e) {
                replace(urls.location(PointStages.SEARCH, null, location.query));
                if (e instanceof InvalidSearchError) {
                    console.error(e);
                } else {
                    throw e;
                }
            }
        } else {
            if (forcePlusBus && trip.isPlusBusAvailable()) {
                TripActions.loadPlusBusAvailability(trip);
            }
            openInAppVersionEndingModal();
        }
        _.defer(callback);
    },

    async onEnter (nextState, replace, callback) {
        this.onComponentLoad(nextState, replace, callback, true);
    },

    async onChange (prevState, nextState, replace, callback) {
        this.onComponentLoad(nextState, replace, callback);
    }
});
